import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';

import { refreshReloadPrompt } from 'hooks';
import PageTemplate from 'components/general/PageTemplate';
import { getServices } from 'api/service';
import Service from './Service';
import {
  columns,
  suggestionPrimaryKey,
  suggestionSecondaryKeys,
} from './service.config';

const Services = () => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const [modalOpen, setModalOpen] = useState(true);
  const [services, setServices] = useState();
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [loading, setLoading] = useState(false);
  const [blockRouteChange, setBlockRouteChange] = useState(false);

  const fetchServices = async () => {
    const { data } = await getServices(pageNumber, pageSize);

    setServices(data);
  };

  useEffect(async () => {
    setLoading(true);

    await fetchServices();
    setLoading(false);
  }, [pageNumber, pageSize]);

  const handleModalOpen = ({ id }) => {
    history.push(`/services/${id}`);
    setModalOpen(true);
  };

  const handleAdd = () => {
    history.push('/services/add');
    setModalOpen(true);
    fetchServices();
  };

  const handleModalClose = (save) => {
    if (save && typeof save === 'boolean') {
      history.block(() => true);
      setModalOpen(false);
    }

    if (!blockRouteChange && !save && typeof save !== 'boolean') {
      setModalOpen(false);
    }

    history.push('/services');
    fetchServices();
    window.removeEventListener('beforeunload', refreshReloadPrompt);
  };

  return (
    <>
      <PageTemplate
        data={get(services, 'data', [])}
        columns={columns}
        suggestionPrimaryKey={suggestionPrimaryKey}
        suggestionSecondaryKeys={suggestionSecondaryKeys}
        handleModalOpen={handleModalOpen}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        rowCount={get(services, 'pagination.total', 0)}
        pageNumber={pageNumber}
        pageSize={pageSize}
        loading={loading}
        handleAdd={handleAdd}
        setModalOpen={setModalOpen}
      />

      <Switch>
        <Route path={`${path}/add`}>
          <Service
            modalOpen={modalOpen}
            handleModalClose={handleModalClose}
            setBlockRouteChange={setBlockRouteChange}
          />
        </Route>

        <Route path={`${path}/:id`}>
          <Service
            modalOpen={modalOpen}
            handleModalClose={handleModalClose}
            setBlockRouteChange={setBlockRouteChange}
          />
        </Route>
      </Switch>
    </>
  );
};
export default Services;
